const EXTRA_API_BASE_URL = 'https://bratan-family.com';

export type SizeStockMap = Record<string, number>;

export const fetchSizeStockForProducts = async (
  productIds: number[]
): Promise<Record<number, SizeStockMap>> => {
  if (!Array.isArray(productIds) || productIds.length === 0) {
    return {};
  }

  const uniqueIds = Array.from(new Set(productIds.filter((id) => Number.isFinite(id))));
  if (uniqueIds.length === 0) {
    return {};
  }

  const idsParam = uniqueIds.join(',');
  const url = `${EXTRA_API_BASE_URL}/sizes.php?action=get_size_stock&product_ids=${encodeURIComponent(
    idsParam
  )}`;

  try {
    const res = await fetch(url);
    if (!res.ok) {
      console.error('Erreur lors du chargement du stock par taille (mini backend)', res.status);
      return {};
    }

    const data = (await res.json()) as any;
    if (!data || typeof data !== 'object') {
      return {};
    }

    const result: Record<number, SizeStockMap> = {};

    for (const [pid, sizes] of Object.entries<any>(data)) {
      const idNum = Number(pid);
      if (!Number.isFinite(idNum) || !sizes || typeof sizes !== 'object') {
        continue;
      }

      const clean: SizeStockMap = {};
      for (const [sizeKey, qty] of Object.entries<any>(sizes)) {
        const n = Number(qty);
        if (!Number.isFinite(n) || n < 0) {
          continue;
        }
        clean[String(sizeKey)] = Math.floor(n);
      }

      result[idNum] = clean;
    }

    return result;
  } catch (error) {
    console.error('Erreur réseau lors du chargement du stock par taille (mini backend)', error);
    return {};
  }
};

export const saveSizeStockForProduct = async (
  productId: number,
  sizeStock: SizeStockMap
): Promise<void> => {
  const idNum = Number(productId);
  if (!Number.isFinite(idNum) || idNum <= 0) {
    return;
  }

  const url = `${EXTRA_API_BASE_URL}/sizes.php?action=save_size_stock`;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: idNum,
        sizeStock,
      }),
    });

    if (!res.ok) {
      console.error('Erreur lors de la sauvegarde du stock par taille (mini backend)', res.status);
    }
  } catch (error) {
    console.error('Erreur réseau lors de la sauvegarde du stock par taille (mini backend)', error);
  }
};

export interface MiniOrderItem {
  productId: number;
  name: string;
  size?: string;
  color?: string;
  quantity: number;
}

export interface MiniOrderRecord {
  orderId: number | null;
  createdAt: string;
  items: MiniOrderItem[];
}

export const registerMiniOrder = async (
  params: {
    orderId: number | null;
    createdAt?: string;
    items: MiniOrderItem[];
  }
): Promise<void> => {
  const url = `${EXTRA_API_BASE_URL}/sizes.php?action=register_order`;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderId: params.orderId,
        createdAt: params.createdAt,
        items: params.items,
      }),
    });

    if (!res.ok) {
      console.error("Erreur lors de l'enregistrement de la commande (mini backend)", res.status);
    }
  } catch (error) {
    console.error("Erreur réseau lors de l'enregistrement de la commande (mini backend)", error);
  }
};

export const fetchMiniOrders = async (): Promise<MiniOrderRecord[]> => {
  const url = `${EXTRA_API_BASE_URL}/sizes.php?action=list_orders`;

  try {
    const res = await fetch(url);
    if (!res.ok) {
      console.error('Erreur lors du chargement des commandes (mini backend)', res.status);
      return [];
    }

    const data = (await res.json()) as any;
    if (!Array.isArray(data)) {
      return [];
    }

    return data as MiniOrderRecord[];
  } catch (error) {
    console.error('Erreur réseau lors du chargement des commandes (mini backend)', error);
    return [];
  }
};
